/* eslint-disable no-param-reassign */
export default {
  setStudent: (state, student) => {
    state.student = student;
  },

  setStudentBillings: (state, billings) => {
    state.studentBillings = billings;
  },

  setStudentContracts: (state, contracts) => {
    state.studentContracts = contracts;
  },

  setStudentBills: (state, bills) => {
    state.studentBills = bills;
  },

  setStudentCards: (state, cards) => {
    state.studentCards = cards;
  },

  setStates: (state, states) => {
    state.states = states;
  },

  setCities: (state, cities) => {
    state.cities = cities;
  },

  setInstitution: (state, institution) => {
    state.institution = institution;
  },

  setBanks: (state, banks) => {
    state.banks = banks;
  },

  setDisallowedReasons: (state, disallowedReasons) => {
    state.disallowedReasons = disallowedReasons;
  },

  setInterruptionReasons: (state, interruptionReasons) => {
    state.interruptionReasons = interruptionReasons;
  },

  setReenrollmentContracts: (state, reenrollmentContracts) => {
    state.reenrollmentContracts = reenrollmentContracts;
  },

  setDebtAgreementInputBills: (state, inputBills) => {
    state.debtAgreementInputBills = inputBills;
  },

  setDebtAgreementRules: (state, rules) => {
    state.debtAgreementRules = rules;
  },

  setLevels: (state, levels) => {
    state.levels = levels;
  },

  setSelectedDiscount: (state, discount) => {
    state.selectedDiscount = discount;
  },

  setSelectedBill: (state, bill) => {
    state.selectedBill = bill;
  },

  setUserPermissions: (state, userPermissions) => {
    state.userPermissions = userPermissions;
  },

  setPaymentDetails: (state, paymentDetails) => {
    state.paymentDetails = paymentDetails;
  },

  setRecipients: (state, recipients) => {
    state.recipients = recipients;
  },

  setQueroPagoRecipient: (state, queroPagoRecipient) => {
    state.queroPagoRecipient = queroPagoRecipient;
  },

  setTransferDays: (state, transferDays) => {
    state.transferDays = transferDays;
  },

  setSelectedRecipient: (state, selectedRecipient) => {
    state.selectedRecipient = selectedRecipient;
  },

  setRecipientEnums: (state, enums) => {
    state.recipientEnums = enums;
  },

  setSelectedPayment: (state, selectedBillPayment) => {
    state.selectedBillPayment = selectedBillPayment;
  },
};
